<section>
  <div class="container">
    <h2>IFC Wealth Advisors</h2>
    <div class="clearfix mb-3"></div>
    <div class="row mb-2">
      @for (advisor of advisors; track advisor) {
        <div class="col-lg-3 col-md-4 col-sm-6">
          <app-advisor-card [data]="advisor"></app-advisor-card>
        </div>
      }
    </div>
  </div>
</section>